import React from 'react';
import {
  Dialog,
  DialogContent,
  Grid,
  Typography,
  Box,
  IconButton
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import imagenDefault from '../images/user.png';

export const ModalVistaTrabajador = ({ open, onClose, trabajador }) => {
  if (!trabajador) return null;

  const API_url = process.env.REACT_APP_API_URL;


  const {
    fullName,
    phone,
    job,
    profile,
    ciudad = 'Santa Cruz',
    sucursal = 'Av. vg. de cotoca 2do 3er anillo',
    descripcion = ''
  } = trabajador;

  return (
    <Dialog
      open={open}
      onClose={onClose}
      PaperProps={{
        style: {
          backgroundColor: '#1a1a1a',
          color: '#fff',
          borderRadius: 8,
          padding: 24,
          maxWidth: 700,
          position: 'relative',
        }
      }}
    >
      <IconButton
        onClick={onClose}
        sx={{
          position: 'absolute',
          top: 8,
          right: 8,
          color: '#fff',
        }}
      >
        <CloseIcon />
      </IconButton>

      <DialogContent sx={{ p: 5 }}>
        <Grid container spacing={3}>
          {/* Columna Izquierda */}
          <Grid item xs={12} md={5}>
            <Box
              display="flex"
              flexDirection="column"
              alignItems="center"
              justifyContent="center"
              height="100%"
            >
              {/* Imagen en círculo */}
              <Box
                sx={{
                  width: 200,
                  height: 200,
                  borderRadius: '50%',
                  overflow: 'hidden',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  marginBottom: 2
                }}
              >
                <img
                  src={profile ? `${API_url}${profile}` : imagenDefault}
                  alt="Foto del trabajador"
                  style={{
                    width: '180px',
                    height: '180px',
                    objectFit: 'cover',
                    borderRadius: '50%'
                  }}
                />
              </Box>

              <Typography variant="h6" gutterBottom sx={{ fontWeight: 'bold', fontSize: '1.3rem', textAlign: 'center' }}>
                {job || 'Cargo no definido'}
              </Typography>
              <Typography
                variant="body1"
                align="left"
                sx={{ maxWidth: 250, lineHeight: 1.5, fontSize: '1rem' }}
              >
                {descripcion}
              </Typography>
            </Box>
          </Grid>

          {/* Columna Derecha */}
          <Grid item xs={12} md={7}>
            <Box
              display="flex"
              flexDirection="column"
              justifyContent="center"
              height="100%"
              gap={2}
              marginLeft='30px'
            >
              <Box>
                <Typography variant="body1" sx={{ fontWeight: 'bold', fontSize: '1.1rem' }}>
                  Nombre
                </Typography>
                <Typography variant="body1" sx={{ fontSize: '1.1rem' }}>
                  {fullName}
                </Typography>
              </Box>
              <Box>
                <Typography variant="body1" sx={{ fontWeight: 'bold', fontSize: '1.1rem' }}>
                  Celular
                </Typography>
                <Typography variant="body1" sx={{ fontSize: '1.1rem' }}>
                  {phone}
                </Typography>
              </Box>
              <Box>
                <Typography variant="body1" sx={{ fontWeight: 'bold', fontSize: '1.1rem' }}>
                  Ciudad
                </Typography>
                <Typography variant="body1" sx={{ fontSize: '1.1rem' }}>
                  {ciudad}
                </Typography>
              </Box>
              <Box>
                <Typography variant="body1" sx={{ fontWeight: 'bold', fontSize: '1.1rem' }}>
                  Sucursal
                </Typography>
                <Typography variant="body1" sx={{ fontSize: '1.1rem' }}>
                  {sucursal}
                </Typography>
              </Box>
            </Box>
          </Grid>
        </Grid>
      </DialogContent>
    </Dialog>
  );
};
